import { useTranslation } from 'react-i18next';
import { PermissionList as PermissionListComponent } from '#admin/component/PermissionList.tsx';

export const PermissionList = () => {
  const { t } = useTranslation();

  return (
    <main className="view-container">
      <section className="flex flex-row place-content-between items-baseline">
        <h4>{t('titles.permissions')}</h4>
      </section>

      <PermissionListComponent className="mt-4 mb-6 p-8" enableAddPermission={false} showDerived={false} />
    </main>
  );
};
